import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, App } from 'ionic-angular';
import { LoginPage } from '../login/login';

/**
 * Generated class for the CreatemodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-createmodal',
    templateUrl: 'createmodal.html',
})
export class CreatemodalPage {

    loginId: string;
    api_key: string;

    texts: any = [];
    language : string;

    constructor(
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
		public app: App
    ) {
    }

    ionViewWillEnter() {
        //// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "createmodal");
        this.language = localStorage.getItem("language");

        this._get_texts();
    }

    _get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).createmodal;
	}

    _close() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/createmodal/createmodal.ts